module.exports = __webpack_public_path__ + "static/img/07b4fcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/simulate/images/success.png
// module id = 697
// module chunks = 2